import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';


const initialState = {
    site: '496',
    delivery: [],
    loading: true,
    reRender: false
};

const fetchDeliveriesStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchDeliveriesSuccess = ( state, action ) => {
    return updateObject( state, {
        deliveryDrivers: action.deliveryDrivers,
        loading: false,
        reRender: true
    } );
};

const fetchDeliveriesFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_DELIVERIES_START: return fetchDeliveriesStart( state, action );
        case actionTypes.FETCH_DELIVERIES_SUCCESS: return fetchDeliveriesSuccess( state, action );
        case actionTypes.FETCH_DELIVERIES_FAIL: return fetchDeliveriesFail( state, action );
        default:
            return state;
    }
};



export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/deliveries.js